import { render, staticRenderFns } from "./dialog-consent-logo.vue?vue&type=template&id=59389d56&"
import script from "./dialog-consent-logo.vue?vue&type=script&lang=js&"
export * from "./dialog-consent-logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports